module.exports = __webpack_public_path__ + "media/images/version_merge/why_support-b5c7d49bc157d47244ba0c11fe0b35e8.svg";